export default __webpack_public_path__ + "static/media/celticfest_logo.e798e0ba.png";